import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const AddBulkMonitoringContext = createContext(null);

type Props = {
  children: ReactElement;
};

const AddBulkMonitoringProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post(`user_monitoring/bulks`, payload);
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      isPending,
      error,
    }),
    [mutateAsync, data, isPending, error],
  );
  return (
    <AddBulkMonitoringContext.Provider value={contextValue}>
      {children}
    </AddBulkMonitoringContext.Provider>
  );
};

export default AddBulkMonitoringProvider;
